module.exports = __webpack_public_path__ + "static/media/generate-pdf-svgrepo-com.0eba8513.svg";